export default __webpack_public_path__ + "static/img/stylem-italia-logo-nosrl.e193eed.png";